module.exports = __webpack_public_path__ + "img/logo_8.ed6622f0.jpg";